var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 260,
    viewBox: "0 0 251 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.83 102.469L234.463 126.926L196.732 134.069L194.453 122.013L139.818 132.321L170.757 259.94H149.115L119.443 136.178L110.176 137.941L84.8958 260H63.1625L87.8841 142.146L28.4948 153.372L23.5444 127.273L9.61397 129.91L0 79.2628L13.9305 76.6257L9.05555 50.5263L174.893 19.1527L172.614 7.09748L210.391 0L215.024 24.4419C223.684 25.7091 231.732 29.641 238.049 35.6899C244.365 41.7389 248.635 49.6038 250.265 58.1897C251.894 66.7756 250.801 75.655 247.138 83.5916C243.475 91.5282 237.425 98.1269 229.83 102.469Z",
    fill: "#F4DB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.b822e0c574498eeb93a41762f8deaa42.svg";
export { ForwardRef as ReactComponent };